<template>
  <div class="bg-white">
    <div class="overflow-hidden bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div class="mx-auto max-w-max lg:max-w-7xl">
        <div class="relative mb-8 md:mb-2 md:px-6">
          <div class="max-w-prose text-base lg:max-w-none">
            <h2 class="font-semibold leading-6 text-teal-600">
              &#10004; Abo erfolgreich abgeschlossen
            </h2>
          </div>
        </div>
        <div class="bg-gray-50 rounded-lg">
          <div class="mx-auto max-w-7xl py-12 px-4 sm:px-6 lg:flex lg:items-center lg:justify-between lg:py-16 lg:px-8">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              <span class="block">
                Willkommen in deinem Studio Pro!
              </span>
              <span class="block text-teal-600">
                Mit Empfehlungen für deine Wachstumsphase.
              </span>
            </h2>
            <div class="mt-8 flex lg:mt-0 lg:flex-shrink-0">
              <div class="inline-flex rounded-md shadow">
                <router-link :to="{name: 'practices.list'}" class="inline-flex items-center justify-center rounded-md border border-transparent bg-teal-600 px-5 py-3 text-base font-medium text-white hover:bg-teal-700">
                  Methoden
                </router-link>
              </div>
              <div class="ml-3 inline-flex rounded-md shadow">
                <router-link :to="{name: 'dashboard'}" class="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-teal-600 hover:bg-teal-50">
                  Podcast
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
